import { render } from "./BreadcrumbLayout.vue?vue&type=template&id=17464754&scoped=true"
import script from "./BreadcrumbLayout.vue?vue&type=script&lang=js"
export * from "./BreadcrumbLayout.vue?vue&type=script&lang=js"

import "./BreadcrumbLayout.vue?vue&type=style&index=0&id=17464754&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17464754"]])

export default __exports__